import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import ShoulderElement from '../../mskchartcomponent/shoulderchart';
import LatmuscleElement from '../../mskchartcomponent/latmusclechart';
import SpineElement from '../../mskchartcomponent/spinechart';
import HiprightElement from '../../mskchartcomponent/hiprightchart';
import HipleftElement from '../../mskchartcomponent/hipleftchart';
import HamstringrightElement from '../../mskchartcomponent/hamstringrightchart';
import GulterightElement from '../../mskchartcomponent/gulterightchart';
import BalanceElement from '../../mskchartcomponent/balancechart';
import PostureElement from '../../mskchartcomponent/posture';

import ReportHeader from "Routes/reportTemplate/header";
import ReportFooter from "Routes/reportTemplate/footer";
import ReportBGImage from "Routes/reportTemplate/watermark";

import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {  
  mskVisualisationDetails,
  creatmskVisualisation
} from 'Actions';

class createvisual extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
      
        super(props);
        this.state = {   
            student:this.props.data.student,
            selyear:this.props.data.selyear,
            selassessment:this.props.data.selassessment,
            visualid:this.props.data.visualid,
            previousLength:0,
            valuelength:0,
        };
       this.selectorRef = React.createRef(null);
  }

   

  render() {

    const { visualisationdetails, loading} = this.props;
    let visualdetails=visualisationdetails.visualimpression;
    let shoulderimpress='';
    let latmuscleimpress='';
    let spineimpress='';
    let hiprightimpress='';
    let hipleftimpress='';
    let hamrightimpress='';
    let gulterightimpress='';
    let balanceimpress='';
    let postureimpress='';
    if(visualdetails.length!=0){
        shoulderimpress= visualdetails[0].shoulder_impression; 
        latmuscleimpress=visualdetails[0].latmuscle_impression; 
        spineimpress=visualdetails[0].spine_impression; 
        hiprightimpress=visualdetails[0].hipright_impression; 
        hipleftimpress=visualdetails[0].hipleft_impression; 
        hamrightimpress=visualdetails[0].hamright_impression; 
        gulterightimpress=visualdetails[0].gulteright_impression; 
        balanceimpress=visualdetails[0].balance_impression; 
        postureimpress=visualdetails[0].posture_impression; 
        
    }

    const styles = {
        mainheading: {
            fontWeight:"bold",
            marginBottom:"50px",
            color:"#000",
            marginTop:"50px"
        },
        subheading: {
            fontWeight:"bold",
            marginTop:"30px", 
            marginBottom:"20px",
            color:"#000",
            position:"relative"
        },
        goals:{
            marginTop:"30px",
            marginBottom:"20px",
            color:"#000"
        },
        goalhead:{
          fontWeight:"bold",
          color:"#000"
        },
        textfield: {
            marginTop:"50px"
        },
        eachchart:{
           padding:"10px",
           position:"relative"
        },
        texare:{
            color:"#000",
            backgroundColor:"unset"
        },
        rctcontent:{
            marginTop:"30px",
            borderRadius: "5px",
            boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
            border: "none",
            transition: "all 0.4s ease-in-out 0s",
            marginBottom: "24px",
            padding:"0px 20px 10px 20px",
            zIndex:"1"
        },
        textptag:{
            wordBreak: "break-all",
            whiteSpace: "pre-wrap",
            color: "rgb(0, 0, 0)",
            fontSize: "15px"
        }
    };


    return (
        <>
        <div className="rwhead">                    
            <input type="button" className="mr-10 mb-10 btn btn-outline-warning float-right" onClick={this.props.onClick} value="Back" />
        </div> 
                <RctCollapsibleCard fullBlock > 
                    <ReportHeader />
                    <div style={styles.rctcontent}>
                        
                        <ReportBGImage />
                        <div className="rwhead">
                            <h2 className="text-center" style={styles.mainheading}>COMPARATIVE ANALYSIS OF MSK SCREENING </h2>
                        </div>
                        
                        <h3 className="text-center" style={styles.subheading}>Shoulder Mobility</h3>                        
                        <div style={styles.eachchart}>
                            <ShoulderElement data={'95%'}/>                        
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals:</h3>
                                <p>Internal Rotation: 90 Degree</p>  
                                <p>External Rotation: 90 Degree</p>  
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <p style={styles.textptag}>{shoulderimpress}</p>
                            </div>
                        </div>
                        
                        <div className="page-break"></div>
                        <h3 className="text-center" style={styles.subheading}>Lats Muscle Length and Combined Elevation Test</h3>
                        <div style={styles.eachchart}> 
                            <LatmuscleElement data={'95%'}/>
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals :</h3>
                                <p>Lats Muscle Length: ≥ 170 Degree</p>  
                                <p>Combined Elevation Test: ≥ 20 Cm</p>  
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <p style={styles.textptag}>{latmuscleimpress}</p>
                            </div>
                        </div>    

                        
                        <ReportFooter />    
                     </div>
                
                </RctCollapsibleCard>    

                <RctCollapsibleCard fullBlock >  
                    <ReportHeader /> 
                    <div style={styles.rctcontent}> 
                        <ReportBGImage />
                            <div className="page-break"></div>
                            <h3 className="text-center" style={styles.subheading}>Spine Mobility</h3>
                            <div style={styles.eachchart}> 
                                <SpineElement data={'95%'}/>
                                <div className="rwhead" style={styles.goals}>
                                    <h3 style={styles.goalhead}>Goals :</h3>
                                    <p>Trunk Forward Flexion: ≥5cm</p>  
                                    <p>Trunk Extension: ≥3cm</p>  
                                    <p>Trunk Side Flexion: ≤3cm</p>  
                                </div>
                                <div className="rwhead" style={styles.textfield}>
                                    <h3 style={styles.goalhead}>Impression :</h3>
                                    <p style={styles.textptag}>{spineimpress}</p>
                                </div>
                            </div>
                            <div className="page-break"></div>
                            <h3 className="text-center" style={styles.subheading}>Hip Complex Mobility 1</h3>
                            <div style={styles.eachchart}>
                                    <HiprightElement data={'95%'}/> 
                                <div className="rwhead" style={styles.goals}>
                                    <h3 style={styles.goalhead}>Goals :</h3>
                                    <p>Iliopsoas Muscle: ≤5 degree</p>  
                                    <p>Piriformis Muscle Length: ≤10 degree</p>  
                                </div>
                                <div className="rwhead" style={styles.textfield}>
                                    <h3 style={styles.goalhead}>Impression :</h3>
                                    <p style={styles.textptag}>{hiprightimpress}</p>
                                </div>
                            </div>  

                            <ReportFooter />
                    </div>
                </RctCollapsibleCard>  
                <RctCollapsibleCard fullBlock >  
                    <ReportHeader /> 
                        <div style={styles.rctcontent}> 
                            <ReportBGImage />
                            <div className="page-break"></div>  
                            <h3 className="text-center" style={styles.subheading}>Hip Complex Mobility 2</h3>
                                <div style={styles.eachchart}>
                                    <HipleftElement data={'95%'}/>
                                <div className="rwhead" style={styles.goals}>
                                    <h3 style={styles.goalhead}>Goals :</h3>                        
                                    <p>Hip Internal Rotation: ≥30 degree</p>
                                    <p>Hip External Rotation: ≥45 degree</p>  
                                </div>
                                <div className="rwhead" style={styles.textfield}>
                                    <h3 style={styles.goalhead}>Impression :</h3>
                                    <p style={styles.textptag}>{hipleftimpress}</p>
                                </div>
                            </div> 

                            <div className="page-break"></div>   
                            <h3 className="text-center" style={styles.subheading}>Hamstring and Quadriceps Muscle Length</h3>
                            <div style={styles.eachchart}>
                                <HamstringrightElement data={'95%'}/>
                                <div className="rwhead" style={styles.goals}>
                                    <h3 style={styles.goalhead}>Goals :</h3>
                                    <p>Hamstring Muscle length: ≥160 degree</p>  
                                    <p>Quadriceps Muscle length: ≥ 80 degree</p> 
                                </div>
                                <div className="rwhead" style={styles.textfield}>
                                    <h3 style={styles.goalhead}>Impression :</h3>
                                    <p style={styles.textptag}>{hamrightimpress}</p>
                                </div>
                            </div>  
                            <ReportFooter />
                        </div>
                </RctCollapsibleCard>          
                <RctCollapsibleCard fullBlock > 
                    <ReportHeader /> 
                    <div style={styles.rctcontent}>  
                        <ReportBGImage />                            
                            <h3 className="text-center" style={styles.subheading}>Glute Stability and TA Stability</h3>
                            <div style={styles.eachchart}>
                                <GulterightElement data={'95%'}/>
                                <div className="rwhead" style={styles.goals}>
                                    <h3 style={styles.goalhead}>Goals :</h3>
                                    <p>Glute Endurance and Stability: Level 3 (≥90 sec)</p>  
                                    <p>TA Control in Supine Position: Level 5</p> 
                                </div>
                                <div className="rwhead" style={styles.textfield}>
                                    <h3 style={styles.goalhead}>Impression :</h3>
                                    <p style={styles.textptag}>{gulterightimpress}</p>
                                </div>  
                            </div> 

                            <h3 className="text-center" style={styles.subheading}>Balance and Proprioception</h3>
                            <div style={styles.eachchart}>
                                <BalanceElement data={'95%'}/>
                                <div className="rwhead" style={styles.goals}>
                                    <h3 style={styles.goalhead}>Goals :</h3>
                                    <p>Eyes Open: {'>'}60 sec</p>  
                                    <p>Eye Closed: {'>'}60 sec</p> 
                                </div>
                                <div className="rwhead" style={styles.textfield}>
                                    <h3 style={styles.goalhead}>Impression :</h3>
                                    <p style={styles.textptag}>{balanceimpress}</p>
                                </div>
                            </div> 

                            <h3 className="text-center" style={styles.subheading}>Posture Analysis</h3>
                            <div style={styles.eachchart}>
                                <PostureElement />
                                <div className="rwhead" style={styles.textfield}>
                                    <h3 style={styles.goalhead}>Impression :</h3>
                                    <p style={styles.textptag}>{postureimpress}</p>
                                </div>
                            </div>    
                            <ReportFooter />
                    </div>
                </RctCollapsibleCard>   
                        
                <div className="rwhead">                    
                    <input type="button" className="mr-10 mb-10 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
                </div> 
        </>
     
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails,
  creatmskVisualisation
})(createvisual); 